import * as React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router';
import { RootState } from '../store';
import Dashboard from 'pages/Dashboard';

const Home = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  if (!user) {
    return <Navigate to="/login" />;
  }
  return <Dashboard />;
};

export default Home;
